module.exports = __webpack_public_path__ + "static/disney+-is-now-live-83eb19338fb6d1ef11b2a3d164b42dd1.png";